import { apiSlice } from '../app/api/apiSlice';
import { updateCreditCards } from '../store/slices/creditCards/creditCards';
import queryString from 'query-string';

export const creditCardsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMyCreditCards: builder.query({
      query: (query={}) => `CreditCard/my?${queryString.stringify(query)}`,
      keepUnusedDataFor: 0,
      providesTags: ['MyCreditCards'],
    }),
    decryptMyCreditCard: builder.query({
      query: (creditCardId) => `CreditCard/my/decrypt/${creditCardId}`,
    }),
    getBuyingEmails: builder.query({
      query: (query) => `CreditCard/BuyingEmails` + (query ? `?${query}` : ``),
      keepUnusedDataFor: 0,
    }),
    getCreditCardsPaged: builder.query({
      query: (query) => `CreditCard/paged${query ? `?${queryString.stringify(query)}` : ''}`,
      providesTags: ['CreditCardPaged'],
    }),
    // Migration of getCreditPrivateDataFromApi
    getCreditPrivateData: builder.query({
      query: (creditCardId) => `CreditCard/DecryptCard/${creditCardId}`,
      providesTags: ['CreditCardPrivateData'],
    }),
    editCreditCard: builder.mutation({
      query: (creditCardEdited) => ({
        url: `creditCard`,
        method: 'PATCH',
        body: creditCardEdited,
      }),
      invalidatesTags: ['CreditCardPaged', 'CreditCardList'],
    }),
    createCreditCard: builder.mutation({
      query: (creditCardEdited) => ({
        url: `creditCard`,
        method: 'POST',
        body: creditCardEdited,
      }),
      invalidatesTags: ['CreditCardPaged', 'CreditCardList'],
    }),
    // New endpoints for getting card types and brand names
    getCardTypes: builder.query({
      query: () => 'creditCard/CreditCardTypes',
      providesTags: ['CreditCardTypes'],
    }),
    getBrandNames: builder.query({
      query: () => 'creditCard/CreditCardBrandNames',
      providesTags: ['CreditCardBrandNames'],
    }),
    getCreditPrivateDataFromApi: builder.query({
      query: (query) => "CreditCard/DecryptCard/" + query,
    }),
    getCreditsCardsFromApi: builder.query({
      query: (query) => "creditCard" + query,
    }),
    getBuyngEmailPrivateFromApi: builder.query({
      query: (query) => "CreditCard/DecryptBuyingEmail/" + query,
    }),
    getBrandNamesFromApi: builder.query({
      query: () => "creditCard/CreditCardBrandNames",
    }),
    getCardTypesFromApi: builder.query({
      query: () => "creditCard/CreditCardTypes",
    }),
    getCreditCardViews: builder.query({
      query: ({ creditCardId, onlyLastView }) =>
        `CreditCard/GetCreditCardViews/?CreditCardId=${creditCardId}&onlyLastView=${onlyLastView}`,
    }),    
    getBuyingEmailsFromApi: builder.query({
      query: (query) => "CreditCard/BuyingEmails" + query,
    }),
  }),
});

export const {
  useGetMyCreditCardsQuery,
  useLazyDecryptMyCreditCardQuery,
  useGetBuyingEmailsQuery,
  useGetCreditCardsPagedQuery,
  useGetCreditPrivateDataQuery,
  useLazyGetCreditPrivateDataQuery,
  useEditCreditCardMutation,
  useCreateCreditCardMutation,
  useGetCardTypesQuery,
  useGetBrandNamesQuery,
  useLazyGetCreditPrivateDataFromApiQuery, 
  useLazyGetCreditsCardsFromApiQuery,
  useLazyGetBuyngEmailPrivateFromApiQuery,
  useLazyGetBrandNamesFromApiQuery,
  useLazyGetCardTypesFromApiQuery,
  useLazyGetCreditCardViewsQuery,
  useLazyGetBuyingEmailsFromApiQuery,
} = creditCardsApi;
